import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:campaign_code/:customer_code/details',
      name: 'details',
      component: () => import('./views/UserDetails.vue'),
    },
    {
      path: '/:campaign_code/:customer_code',
      name: 'qr_code',
      component: () => import('./views/Home.vue'),
    },
    // Catch all other routes
    {
      path: '*',
      component: () => import('./views/CampaignNotFound.vue'),
    },
  ],
});
